var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloseWeek(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.69668 1.61502V0H4.89099V1.61502H11.109V0H12.3033V1.61502H16V8.51645L14.8057 7.33335V6.46009H1.19431V14.8169H14.8057V14L16 12.8169V16H0V1.61502H3.69668ZM1.19431 5.277V2.79812H14.8057V5.277H1.19431Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2319 7.74075L11.8248 8.14816L12.7798 9.10303C13.3051 9.62822 13.7348 10.0643 13.7348 10.072C13.7348 10.0798 11.7545 10.0861 9.3341 10.0861H4.93335V11.2472H9.3341C11.7545 11.2472 13.7348 11.2535 13.7348 11.2613C13.7348 11.2691 13.3051 11.7051 12.7798 12.2303L11.8248 13.1852L12.2319 13.5926C12.4558 13.8167 12.6475 14 12.658 14C12.6684 14 13.4268 13.25 14.3435 12.3333L16.0101 10.6667L14.3435 9C13.4268 8.08333 12.6684 7.33333 12.658 7.33333C12.6475 7.33333 12.4558 7.51667 12.2319 7.74075Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseWeek);
export default __webpack_public_path__ + "static/media/icon--close-week.9a8c177130f02463fd96be48ebe3520e.svg";
export { ForwardRef as ReactComponent };